// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1u6fH","title":"InfoRow_title__3_v8b"};